var BEES = require('serialisers/byte-encoded-enum-serialiser');
var TopicWillParameters = require('./topic-will-parameters');
var Codec = require('io/codec');

var serialiser = {
    read : function(input) {
        var path = Codec.readString(input);
        var will = BEES.read(input, TopicWillParameters.Will);
        
        return new TopicWillParameters(path, will);
    },
    write : function(out, params) {
        Codec.writeString(out, params.path);
        BEES.write(out, params.will);
    }
};

module.exports = serialiser;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/wills/topic-will-parameters-serialiser.js
// module id = 1093
// module chunks = 1